import React, { useState, useContext, useEffect, useReducer } from 'react';
import Breadcrumb from '../../shared/Breadcrumb';
import SideNav from '../shared/SideNav';
import { AuthContext } from '../../../contexts/AuthContext';
import Util from '../../../Util';
import axios from 'axios';
import { apiRoutes } from '../../../AppSettings';
import "../../../assets/plugins/bootstrap-tagsinput/css/bootstrap-tagsinput.css";
import '../../../assets/plugins/dropzone/dropzone.min.css';
import alertify from 'alertifyjs';
import { Form } from 'react-bootstrap';

const FIELD_FIRSTNAME = "firstName"
const FIELD_LASTNAME = "lastName";
const FIELD_PHONE = "phone";
const FIELD_GENDER = "gender";
const FIELD_BIOGRAPHY = "biography";
const FIELD_DOB = "dob";
const FIELD_CLINICNAME = "clinicName";
const FIELD_CLINICADDRESS = "clinicAddreshh";
const FIELD_ADDRESSLINE1 = "addressName1";
const FIELD_ADDRESSLINE2 = "addressName2";
const FIELD_CITY = "city";
const FIELD_STATE = "state";
const FIELD_COUNTRY = "country";
const FIELD_ZIPCODE = "zipCode";
const FIELD_CONSULTINGFEE = "consultingfee";

//state variables 
const LOAD_PROFILE = "LOAD_PROFILE";
const LOAD_AWARDS = "LOAD_AWARDS";
const LOAD_EXPERIENCE = "LOAD_EXPERIENCE";
const LOAD_EDUCATION = "LOAD_EDUCATION";
const LOAD_MEMBERSHIP = "LOAD_MEMBERSHIP";
const LOAD_REGISTRATION = "LOAD_REGISTRATION";
const LOAD_CONSULTINGFEE = "LOAD_CONSULTINGFEE";
const LOAD_SERVICE = "LOAD_SERVICE";
const LOAD_SPECIALIZATION = "LOAD_SPECIALIZATION";

const initialValue = {
	profile: {}
}

const reducer = (state, action) => {
	switch (action.type) {
		case LOAD_PROFILE:
			return { ...state, profile: action.profile };
		case LOAD_AWARDS:
			console.log(action.awards);
			return { ...state, profile: { ...state.profile, doctorAwards: action.awards } };
		case LOAD_EXPERIENCE:
			return { ...state, profile: { ...state.profile, doctorExperiences: action.experiences } };
		case LOAD_EDUCATION:
			return { ...state, profile: { ...state.profile, doctorEducations: action.educations } };
		case LOAD_MEMBERSHIP:
			return { ...state, profile: { ...state.profile, doctorMemberships: action.memberships } };
		case LOAD_REGISTRATION:
			return { ...state, profile: { ...state.profile, doctorRegistrations: action.registrations } };
		case LOAD_CONSULTINGFEE:
			return { ...state, profile: { ...state.profile, doctorVisitingFee: action.visitingFee } };
		case LOAD_SERVICE:
			return { ...state, profile: { ...state.profile, doctorServices: action.services } };
		case LOAD_SPECIALIZATION:
			return { ...state, profile: { ...state.profile, doctorSpecializations: action.specialization } };
		case "UPDATE_SERVICE":
			return { ...state, services: action.services };
	}
}

const DoctorProfileSetting = () => {
	const { userState } = useContext(AuthContext);
	const [doctor, setDoctor] = useState(userState.loggedInUser);
	const [profile, setProfile] = useState({});
	const [state, dispature] = useReducer(reducer, initialValue);

	//console.log(getCommaseperatedValue(profile.doctorServices,'Service'));

	const getFiles = (e) => {
		if (e.target.files[0].size <= 2097152) {
			var reader = new FileReader();
			reader.onload = function (upload) {
				dispature({ type: LOAD_PROFILE, profile: { ...state.profile, profileImage: upload.target.result } });
			};
			reader.readAsDataURL(e.target.files[0]);
		}
	}

	const options = {
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
			'Authorization': 'bearer ' + userState.token
		}
	};
	const updae = (docServices) => {
		var s = Util.getCommaseperatedValue(docServices, 'service');
		dispature({ type: 'UPDATE_SERVICE', services: s });
	}

	useEffect(() => {
		axios.get(apiRoutes.getDoctorProfile + doctor.doctorId, options)
			.then((response) => {
				if (response.status === 200) {
					const data = response.data;
					console.log(response.data)
					dispature({ type: LOAD_PROFILE, profile: response.data });
				}
			}, (error) => {
				console.log(error);
			});
	}, []);

	const handleSubmit = e => {
		console.log(state.profile);

		axios.post(apiRoutes.UpdateDoctor, JSON.stringify(state.profile), options)
			.then((response) => {
				if (response.status === 200) {
					alertify.success("Profile updated successfully");
				}
			}, (error) => {
				console.log(error);
			});
	}

	const handleOnChange = (e, fieldToChange) => {
		switch (fieldToChange) {
			case FIELD_FIRSTNAME:
				dispature({ type: LOAD_PROFILE, profile: { ...state.profile, firstName: e.target.value } });
				break;
			case FIELD_LASTNAME:
				dispature({ type: LOAD_PROFILE, profile: { ...state.profile, lastName: e.target.value } });
				break;
			case FIELD_PHONE:
				dispature({ type: LOAD_PROFILE, profile: { ...state.profile, phone: e.target.value } });
				break;
			case FIELD_GENDER:
				console.log(e.target.value);
				dispature({ type: LOAD_PROFILE, profile: { ...state.profile, gender: e.target.value } });
				break;
			case FIELD_BIOGRAPHY:
				dispature({ type: LOAD_PROFILE, profile: { ...state.profile, biography: e.target.value } });
				break;
			case FIELD_DOB:
				dispature({ type: LOAD_PROFILE, profile: { ...state.profile, dob: e.target.value } });
				break;
			case FIELD_CLINICNAME:
				dispature({ type: LOAD_PROFILE, profile: { ...state.profile, clinicName: e.target.value } });
				break;
			case FIELD_CLINICADDRESS:
				dispature({ type: LOAD_PROFILE, profile: { ...state.profile, clinicAddress: e.target.value } });
				break;
			case FIELD_ADDRESSLINE1:
				dispature({ type: LOAD_PROFILE, profile: { ...state.profile, addressLine1: e.target.value } });
				break;
			case FIELD_ADDRESSLINE2:
				dispature({ type: LOAD_PROFILE, profile: { ...state.profile, addressLine2: e.target.value } });
				break;
			case FIELD_CITY:
				dispature({ type: LOAD_PROFILE, profile: { ...state.profile, city: e.target.value } });
				break;
			case FIELD_STATE:
				dispature({ type: LOAD_PROFILE, profile: { ...state.profile, state: e.target.value } });
				break;
			case FIELD_COUNTRY:
				dispature({ type: LOAD_PROFILE, profile: { ...state.profile, country: e.target.value } });
				break;
			case FIELD_ZIPCODE:
				dispature({ type: LOAD_PROFILE, profile: { ...state.profile, zipCode: e.target.value } });
				break;
			case FIELD_CONSULTINGFEE:
				if (state.profile.doctorVisitingFee != undefined && state.profile.doctorVisitingFee.length > 0) {
					state.profile.doctorVisitingFee[0].consultingFee = e.target.value;
				} else {
					let newItem = {
						doctorVisitingHourId: 0,
						doctorId: doctor.doctorId,
						day: '',
						visitingHours: '',
						consultingFee: e.target.value
					}
					state.profile.doctorVisitingFee.push(newItem);
				}

				dispature({ type: LOAD_CONSULTINGFEE, visitingFee: state.profile.doctorVisitingFee })
				break;
		}
	}

	const handleOnChangeAward = (e, idToChange, field) => {
		let value = e.target.value;

		console.log(idToChange);
		state.profile.doctorAwards.forEach(element => {
			if (element.doctorAwardId === idToChange) {
				switch (field) {
					case "award":
						element.award = e.target.value;
						break;
					case "year":
						element.year = e.target.value;
						break;
				}
			}
			//	updateValues(element, field, value)
		})
		dispature({ type: LOAD_AWARDS, awards: state.profile.doctorAwards })
	};

	const handleAwardsAddMore = () => {
		console.log("add more")
		let minId = 0;
		if (state.profile.doctorAwards.length > 0) {
			minId = Math.min.apply(Math, state.profile.doctorAwards.map(function (o) {
				return o.doctorAwardId;
			}));
		}

		minId = minId == 0 ? 1 : minId;

		let newItem = {
			award: "",
			description: "",
			doctorAwardId: minId < 0 ? (minId - 1) : (minId * -1),
			doctorId: doctor.doctorId,
			isActive: true,
			month: "",
			year: ""
		}

		state.profile.doctorAwards.push(newItem);

		dispature({ type: LOAD_AWARDS, awards: state.profile.doctorAwards })
	}

	const handleDeleteAwards = (id) => {
		dispature({ type: LOAD_AWARDS, awards: state.profile.doctorAwards.filter((item) => item.doctorAwardId !== id) });
	}

	const handleOnChangeExperience = (e, idToChange, field) => {
		let value = e.target.value;

		console.log(idToChange);
		state.profile.doctorExperiences.forEach(element => {
			if (element.doctorExperienceId === idToChange) {
				switch (field) {
					case "hospitalName":
						element.hospitalName = e.target.value;
						break;
					case "fromDate":
						element.fromDate = e.target.value;
						break;
					case "toDate":
						element.toDate = e.target.value;
						break;
					case "designation":
						element.designation = e.target.value;
						break;
				}
			}
		})
		dispature({ type: LOAD_EXPERIENCE, experiences: state.profile.doctorExperiences })
	};

	const handleExperienceAddMore = () => {
		console.log("add more")
		let minId = 0;
		if (state.profile.doctorExperiences.length > 0) {
			minId = Math.min.apply(Math, state.profile.doctorExperiences.map(function (o) {
				return o.doctorExperienceId;
			}));
		}

		minId = minId == 0 ? 1 : minId;

		let newItem = {
			designation: "",
			doctorExperienceId: minId < 0 ? (minId - 1) : (minId * -1),
			doctorId: doctor.doctorId,
			fromDate: "",
			hospitalName: "",
			isActive: true,
			toDate: ''
		}

		state.profile.doctorExperiences.push(newItem);

		dispature({ type: LOAD_EXPERIENCE, experiences: state.profile.doctorExperiences })
	}

	const handleDeleteExperience = (id) => {
		dispature({ type: LOAD_EXPERIENCE, experiences: state.profile.doctorExperiences.filter((item) => item.doctorExperienceId !== id) });
	}

	const handleOnChangeEducation = (e, idToChange, field) => {
		console.log(idToChange);
		state.profile.doctorEducations.forEach(element => {
			if (element.doctorEducationId === idToChange) {
				switch (field) {
					case "degree":
						element.degree = e.target.value;
						break;
					case "institute":
						element.institute = e.target.value;
						break;
					case "year":
						element.year = e.target.value;
						break;
				}
			}
		})
		dispature({ type: LOAD_EDUCATION, educations: state.profile.doctorEducations })
	};

	const handleEducationAddMore = () => {
		console.log("add more")
		let minId = 0;
		if (state.profile.doctorEducations.length > 0) {
			minId = Math.min.apply(Math, state.profile.doctorEducations.map(function (o) {
				return o.doctorEducationId;
			}));
		}

		minId = minId == 0 ? 1 : minId;

		let newItem = {
			degree: "",
			doctorEducationId: minId < 0 ? (minId - 1) : (minId * -1),
			doctorId: doctor.doctorId,
			institute: "",
			isActive: true,
			year: ""
		}

		state.profile.doctorEducations.push(newItem);

		dispature({ type: LOAD_EDUCATION, educations: state.profile.doctorEducations })
	}

	const handleDeleteEducation = (id) => {
		dispature({ type: LOAD_EDUCATION, educations: state.profile.doctorEducations.filter((item) => item.doctorEducationId !== id) });
	}

	const handleOnChangeMembership = (e, idToChange, field) => {
		console.log(idToChange);
		state.profile.doctorMemberships.forEach(element => {
			if (element.doctorMembershipId === idToChange) {
				switch (field) {
					case "membership":
						element.membership = e.target.value;
						break;
				}
			}
		})
		dispature({ type: LOAD_MEMBERSHIP, memberships: state.profile.doctorMemberships })
	};

	const handleMembershipAddMore = () => {
		console.log("add more")
		let minId = 0;
		if (state.profile.doctorMemberships.length > 0) {
			minId = Math.min.apply(Math, state.profile.doctorMemberships.map(function (o) {
				return o.doctorMembershipId;
			}));
		}

		minId = minId == 0 ? 1 : minId;

		let newItem = {
			doctorMembershipId: minId < 0 ? (minId - 1) : (minId * -1),
			membership: "",
			isActive: true,
			doctorId: doctor.doctorId
		}

		state.profile.doctorMemberships.push(newItem);

		dispature({ type: LOAD_MEMBERSHIP, memberships: state.profile.doctorMemberships })
	}

	const handleDeleteMembership = (id) => {
		dispature({ type: LOAD_MEMBERSHIP, memberships: state.profile.doctorMemberships.filter((item) => item.doctorMembershipId !== id) });
	}

	const handleOnChangeService = (e, idToChange, field) => {
		console.log(idToChange);
		state.profile.doctorServices.forEach(element => {
			if (element.doctorServiceId === idToChange) {
				switch (field) {
					case "service":
						element.service = e.target.value;
						break;
				}
			}
		})
		dispature({ type: LOAD_SERVICE, services: state.profile.doctorServices })
	};

	const handleServiceAddMore = () => {
		console.log("add more")
		let minId = 0;
		if (state.profile.doctorServices.length > 0) {
			minId = Math.min.apply(Math, state.profile.doctorServices.map(function (o) {
				return o.doctorServiceId;
			}));
		}

		minId = minId == 0 ? 1 : minId;

		let newItem = {
			doctorServiceId: minId < 0 ? (minId - 1) : (minId * -1),
			service: "",
			isActive: true,
			doctorId: doctor.doctorId
		}

		state.profile.doctorServices.push(newItem);

		dispature({ type: LOAD_SERVICE, services: state.profile.doctorServices })
	}

	const handleDeleteService = (id) => {
		dispature({ type: LOAD_SERVICE, services: state.profile.doctorServices.filter((item) => item.doctorServiceId !== id) });
	}

	///
	const handleOnChangeSpecialization = (e, idToChange, field) => {
		console.log(idToChange);
		state.profile.doctorSpecializations.forEach(element => {
			if (element.doctorSpecializationId === idToChange) {
				switch (field) {
					case "specialization":
						element.specialization = e.target.value;
						break;
				}
			}
		})
		dispature({ type: LOAD_SPECIALIZATION, specialization: state.profile.doctorSpecializations })
	};

	const handleSpecializationAddMore = () => {
		console.log("add more")
		let minId = 0;
		if (state.profile.doctorSpecializations.length > 0) {
			minId = Math.min.apply(Math, state.profile.doctorSpecializations.map(function (o) {
				return o.doctorSpecializationId;
			}));
		}

		minId = minId == 0 ? 1 : minId;

		let newItem = {
			doctorSpecializationId: minId < 0 ? (minId - 1) : (minId * -1),
			specialization: "",
			isActive: true,
			doctorId: doctor.doctorId
		}

		state.profile.doctorSpecializations.push(newItem);

		dispature({ type: LOAD_SPECIALIZATION, specialization: state.profile.doctorSpecializations })
	}

	const handleDeleteSpecialization = (id) => {
		dispature({ type: LOAD_SPECIALIZATION, specialization: state.profile.doctorSpecializations.filter((item) => item.doctorSpecializationId !== id) });
	}
	///

	const handleOnChangeRegistration = (e, idToChange, field) => {
		console.log(idToChange);
		state.profile.doctorRegistrations.forEach(element => {
			if (element.doctorRegistrationId === idToChange) {
				switch (field) {
					case "registrations":
						element.registrations = e.target.value;
						break;
					case "year":
						element.year = e.target.value;
						break;
				}
			}
		})
		dispature({ type: LOAD_REGISTRATION, registrations: state.profile.doctorRegistrations })
	};

	const handleRegistrationAddMore = () => {
		console.log("add more")
		let minId = 0;
		if (state.profile.doctorRegistrations.length > 0) {
			minId = Math.min.apply(Math, state.profile.doctorRegistrations.map(function (o) {
				return o.doctorRegistrationId;
			}));
		}

		minId = minId == 0 ? 1 : minId;

		let newItem = {
			doctorRegistrationId: minId < 0 ? (minId - 1) : (minId * -1),
			doctorId: doctor.doctorId,
			registrations: "",
			year: "",
			isActive: true
		}

		state.profile.doctorRegistrations.push(newItem);

		dispature({ type: LOAD_REGISTRATION, registrations: state.profile.doctorRegistrations })
	}

	const handleDeleteRegistration = (id) => {
		dispature({ type: LOAD_REGISTRATION, registrations: state.profile.doctorRegistrations.filter((item) => item.doctorRegistrationId !== id) });
	}

	return (
		<div>
			<Breadcrumb title='Profile Settings' />
			<div className="content">
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
							<SideNav applyCssFor='doctorprofilesetting' user={doctor} />
						</div>
						<div className="col-md-7 col-lg-8 col-xl-9">
							<Form onSubmit={e => { e.preventDefault(); handleSubmit(); }}>
								<div className="card">
									<div className="card-body">
										<h4 className="card-title">Basic Information</h4>
										<div className="row form-row">
											<div className="col-md-12">
												<div className="form-group">
													<div className="change-avatar">
														<div className="profile-img">
															<img src={Util.loadImage(state.profile.profileImage)} alt="User Image" />
														</div>
														<div className="upload-img">
															<div className="change-photo-btn">
																<span><i className="fa fa-upload"></i> Upload Photo</span>
																<input type="file" className="upload"
																	onChange={getFiles}
																	required
																	accept="image/*" />
															</div>
															<small className="form-text text-muted">Allowed JPG, GIF or PNG. Max size of 2MB</small>
														</div>
													</div>
												</div>
											</div>
											<div className="col-md-6">
												<div className="form-group">
													<label>First Name <span className="text-danger">*</span></label>
													<input type="text" className="form-control" value={state.profile.firstName} onChange={(e) => handleOnChange(e, FIELD_FIRSTNAME)} />
												</div>
											</div>
											<div className="col-md-6">
												<div className="form-group">
													<label>Last Name <span className="text-danger">*</span></label>
													<input type="text" className="form-control" value={state.profile.lastName} onChange={(e) => handleOnChange(e, FIELD_LASTNAME)} />
												</div>
											</div>
											<div className="col-md-6">
												<div className="form-group">
													<label>Email <span className="text-danger">*</span></label>
													<input type="email" className="form-control" value={state.profile.emailAddress} readonly />
												</div>
											</div>
											<div className="col-md-6">
												<div className="form-group">
													<label>Phone Number</label>
													<input type="text" className="form-control" required value={state.profile.phone} onChange={(e) => handleOnChange(e, FIELD_PHONE)} />
												</div>
											</div>
											{
												console.log(state.profile.gender)
											}
											<div className="col-md-6">
												<div className="form-group">
													<label>Gender</label>
													<select className="form-control select" required value={state.profile.gender} onChange={e => handleOnChange(e, FIELD_GENDER)} >
														<option>Select</option>
														<option value="Male">Male</option>
														<option value="Female">Female</option>
													</select>
												</div>
											</div>
											<div className="col-md-6">
												<div className="form-group mb-0">
													<label>Date of Birth</label>
													<input type="text" className="form-control" required value={state.profile.dob} onChange={(e) => handleOnChange(e, FIELD_DOB)} />
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="card">
									<div className="card-body">
										<h4 className="card-title">About Me</h4>
										<div className="form-group mb-0">
											<label>Biography</label>
											<textarea className="form-control" rows="5" required value={state.profile.biography} onChange={(e) => handleOnChange(e, FIELD_BIOGRAPHY)}></textarea>
										</div>
									</div>
								</div>
								<div className="card">
									<div className="card-body">
										<h4 className="card-title">Clinic Info</h4>
										{
											state.profile.doctorClinic != undefined &&
											state.profile.doctorClinic.map(item => (
												<div className="row form-row">
													<div className="col-md-6">
														<div className="form-group">
															<label>Clinic Name</label>
															<input type="text" className="form-control" value={item.clinicName} onChange={(e) => handleOnChange(e, FIELD_CLINICNAME)} />
														</div>
													</div>
													<div className="col-md-6">
														<div className="form-group">
															<label>Clinic Address</label>
															<input type="text" className="form-control" value={item.clinicAddress} onChange={(e) => handleOnChange(e, FIELD_CLINICADDRESS)} />
														</div>
													</div>
													<div className="col-md-12">
														<div className="form-group">
															<label>Clinic Images</label>
														</div>
														<div className="upload-wrap">
															<div className="upload-images">
																<img src="assets/img/features/feature-01.jpg" alt="Upload Image" />
																<a href="javascript:void(0);" className="btn btn-icon btn-danger btn-sm"><i className="far fa-trash-alt"></i></a>
															</div>
															<div className="upload-images">
																<img src="assets/img/features/feature-02.jpg" alt="Upload Image" />
																<a href="javascript:void(0);" className="btn btn-icon btn-danger btn-sm"><i className="far fa-trash-alt"></i></a>
															</div>
														</div>
														<div className="form-group">
															<label> </label>
															<form action="#" className="dropzone"></form>
														</div>
													</div>
												</div>
											))
										}
									</div>
								</div>
								<div className="card contact-card">
									<div className="card-body">
										<h4 className="card-title">Contact Details</h4>
										<div className="row form-row">
											<div className="col-md-6">
												<div className="form-group">
													<label>Address Line 1</label>
													<input type="text" className="form-control" required value={state.profile.addressLine1} onChange={(e) => handleOnChange(e, FIELD_ADDRESSLINE1)} />
												</div>
											</div>
											<div className="col-md-6">
												<div className="form-group">
													<label className="control-label">Address Line 2</label>
													<input type="text" className="form-control" required value={state.profile.addressLine2} onChange={(e) => handleOnChange(e, FIELD_ADDRESSLINE2)} />
												</div>
											</div>
											<div className="col-md-6">
												<div className="form-group">
													<label className="control-label">City</label>
													<input type="text" className="form-control" required value={state.profile.city} onChange={(e) => handleOnChange(e, FIELD_CITY)} />
												</div>
											</div>

											<div className="col-md-6">
												<div className="form-group">
													<label className="control-label">State / Province</label>
													<input type="text" className="form-control" required value={state.profile.state} onChange={(e) => handleOnChange(e, FIELD_STATE)} />
												</div>
											</div>
											<div className="col-md-6">
												<div className="form-group">
													<label className="control-label">Country</label>
													<input type="text" className="form-control" required value={state.profile.country} onChange={(e) => handleOnChange(e, FIELD_COUNTRY)} />
												</div>
											</div>
											<div className="col-md-6">
												<div className="form-group">
													<label className="control-label">Postal Code</label>
													<input type="text" className="form-control" required value={state.profile.zipCode} onChange={(e) => handleOnChange(e, FIELD_ZIPCODE)} />
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="card">
									<div className="card-body">
										<h4 className="card-title">Pricing</h4>
										<div className="row custom_price_cont" id="custom_price_cont" >
											<div className="col-md-4">
												<label>Consulting Fee</label>
												<input type="text" className="form-control" id="custom_rating_input" name="custom_rating_count"
													onChange={(e) => handleOnChange(e, FIELD_CONSULTINGFEE)}
													value={state.profile.doctorVisitingFee && state.profile.doctorVisitingFee.length > 0 ? state.profile.doctorVisitingFee[0].consultingFee : 0} />
											</div>
										</div>
									</div>
								</div>
								<div className="card">
									<div className="card-body">
										<h4 className="card-title">Services</h4>
										<div className="membership-info">
											{
												state.profile.doctorServices != undefined &&
												state.profile.doctorServices.map(item => (
													<div className="row form-row membership-cont" key={item.doctorServiceId}>
														<div className="col-12 col-md-10 col-lg-5">

															<div className="form-group">
																<label>Services</label>
																<input type="text" className="form-control" value={item.service} onChange={(e) => handleOnChangeService(e, item.doctorServiceId, "service")} />
															</div>
														</div>
														<div class="col-12 col-md-2 col-lg-2">
															<label class="d-md-block d-sm-none d-none">&nbsp;</label>
															<a onClick={() => handleDeleteService(item.doctorServiceId)} class="btn btn-danger trash"><i class="far fa-trash-alt"></i></a>
														</div>
													</div>
												))
											}

										</div>
										<div className="add-more">
											<a onClick={() => handleServiceAddMore()} className="add-membership"><i className="fa fa-plus-circle"></i> Add More</a>
										</div>
									</div>
								</div>

								<div className="card">
									<div className="card-body">
										<h4 className="card-title">Specializations</h4>
										<div className="membership-info">
											{
												state.profile.doctorSpecializations != undefined &&
												state.profile.doctorSpecializations.map(item => (
													<div className="row form-row membership-cont" key={item.doctorSpecializationId}>
														<div className="col-12 col-md-10 col-lg-5">

															<div className="form-group">
																<label>Services</label>
																<input type="text" className="form-control" value={item.specialization} onChange={(e) => handleOnChangeSpecialization(e, item.doctorSpecializationId, "specialization")} />
															</div>
														</div>
														<div class="col-12 col-md-2 col-lg-2">
															<label class="d-md-block d-sm-none d-none">&nbsp;</label>
															<a onClick={() => handleDeleteSpecialization(item.doctorSpecializationId)} class="btn btn-danger trash"><i class="far fa-trash-alt"></i></a>
														</div>
													</div>
												))
											}

										</div>
										<div className="add-more">
											<a onClick={() => handleSpecializationAddMore()} className="add-membership"><i className="fa fa-plus-circle"></i> Add More</a>
										</div>
									</div>
								</div>
								<div className="card">
									<div className="card-body">
										<h4 className="card-title">Education</h4>
										<div className="education-info">
											{
												state.profile.doctorEducations != undefined &&
												state.profile.doctorEducations.map(item => (
													<div className="row form-row education-cont" key={item.doctorEducationId}>
														<div className="col-12 col-md-10 col-lg-11">
															<div className="row form-row">
																<div className="col-12 col-md-6 col-lg-4">
																	<div className="form-group">
																		<label>Degree</label>
																		<input type="text" className="form-control" value={item.degree} onChange={(e) => handleOnChangeEducation(e, item.doctorEducationId, "degree")} />
																	</div>
																</div>
																<div className="col-12 col-md-6 col-lg-4">
																	<div className="form-group">
																		<label>College/Institute</label>
																		<input type="text" className="form-control" value={item.institute} onChange={(e) => handleOnChangeEducation(e, item.doctorEducationId, "institute")} />
																	</div>
																</div>
																<div className="col-12 col-md-6 col-lg-4">
																	<div className="form-group">
																		<label>Year of Completion</label>
																		<input type="text" className="form-control" value={item.year} onChange={(e) => handleOnChangeEducation(e, item.doctorEducationId, "year")} />
																	</div>
																</div>
															</div>
														</div>
														<div class="col-12 col-md-2 col-lg-1">
															<label class="d-md-block d-sm-none d-none">&nbsp;</label>
															<a onClick={() => handleDeleteEducation(item.doctorEducationId)} class="btn btn-danger trash"><i class="far fa-trash-alt"></i></a>
														</div>
													</div>
												))
											}

										</div>
										<div className="add-more">
											<a onClick={() => handleEducationAddMore()} className="add-education"><i className="fa fa-plus-circle"></i> Add More</a>
										</div>
									</div>
								</div>
								<div className="card">
									<div className="card-body">
										<h4 className="card-title">Experience</h4>
										<div className="experience-info">
											{
												state.profile.doctorExperiences != undefined &&
												state.profile.doctorExperiences.map(item => (
													<div className="row form-row experience-cont" key={item.doctorExperienceId}>
														<div className="col-12 col-md-10 col-lg-11">
															<div className="row form-row">
																<div className="col-12 col-md-6 col-lg-4">
																	<div className="form-group">
																		<label>Hospital Name</label>
																		<input type="text" className="form-control" value={item.hospitalName} onChange={(e) => handleOnChangeExperience(e, item.doctorExperienceId, "hospitalName")} />
																	</div>
																</div>
																<div className="col-12 col-md-6 col-lg-4">
																	<div className="form-group">
																		<label>From</label>
																		<input type="text" className="form-control" value={item.fromDate} onChange={(e) => handleOnChangeExperience(e, item.doctorExperienceId, "fromDate")} />
																	</div>
																</div>
																<div className="col-12 col-md-6 col-lg-4">
																	<div className="form-group">
																		<label>To</label>
																		<input type="text" className="form-control" value={item.toDate} onChange={(e) => handleOnChangeExperience(e, item.doctorExperienceId, "toDate")} />
																	</div>
																</div>
																<div className="col-12 col-md-6 col-lg-4">
																	<div className="form-group">
																		<label>Designation</label>
																		<input type="text" className="form-control" value={item.designation} onChange={(e) => handleOnChangeExperience(e, item.doctorExperienceId, "designation")} />
																	</div>
																</div>
															</div>
														</div>
														<div class="col-12 col-md-2 col-lg-1">
															<label class="d-md-block d-sm-none d-none">&nbsp;</label>
															<a onClick={() => handleDeleteExperience(item.doctorExperienceId)} class="btn btn-danger trash"><i class="far fa-trash-alt"></i></a>
														</div>
													</div>
												))
											}
										</div>
										<div className="add-more">
											<a onClick={() => handleExperienceAddMore()} className="add-experience"><i className="fa fa-plus-circle"></i> Add More</a>
										</div>
									</div>
								</div>
								<div className="card">
									<div className="card-body">
										<h4 className="card-title">Awards</h4>
										<div className="awards-info">
											{
												state.profile.doctorAwards != undefined &&
												state.profile.doctorAwards.map(item => (
													<div className="row form-row awards-cont" key={item.doctorAwardId}>
														<div className="col-12 col-md-5">
															<div className="form-group">
																<label>Awards</label>
																<input type="text" className="form-control" value={item.award} onChange={(e) => handleOnChangeAward(e, item.doctorAwardId, "award")} />
															</div>
														</div>
														<div className="col-12 col-md-5">
															<div className="form-group">
																<label>Year</label>
																<input type="text" className="form-control" value={item.year} onChange={(e) => handleOnChangeAward(e, item.doctorAwardId, "year")} />
															</div>
														</div>
														<div class="col-12 col-md-2">
															<label class="d-md-block d-sm-none d-none">&nbsp;</label>
															<a onClick={() => handleDeleteAwards(item.doctorAwardId)} class="btn btn-danger trash"><i class="far fa-trash-alt"></i></a>
														</div>
													</div>
												))
											}
										</div>
										<div className="add-more">
											<a className="add-award" onClick={() => handleAwardsAddMore()} ><i className="fa fa-plus-circle"></i> Add More</a>
										</div>
									</div>
								</div>
								<div className="card">
									<div className="card-body">
										<h4 className="card-title">Memberships</h4>
										<div className="membership-info">
											{
												state.profile.doctorMemberships != undefined &&
												state.profile.doctorMemberships.map(item => (
													<div className="row form-row membership-cont" key={item.doctorMembershipId}>
														<div className="col-12 col-md-10 col-lg-5">

															<div className="form-group">
																<label>Memberships</label>
																<input type="text" className="form-control" value={item.membership} onChange={(e) => handleOnChangeMembership(e, item.doctorMembershipId, "membership")} />
															</div>
														</div>
														<div class="col-12 col-md-2 col-lg-2">
															<label class="d-md-block d-sm-none d-none">&nbsp;</label>
															<a onClick={() => handleDeleteMembership(item.doctorMembershipId)} class="btn btn-danger trash"><i class="far fa-trash-alt"></i></a>
														</div>
													</div>
												))
											}

										</div>
										<div className="add-more">
											<a onClick={() => handleMembershipAddMore()} className="add-membership"><i className="fa fa-plus-circle"></i> Add More</a>
										</div>
									</div>
								</div>
								<div className="card">
									<div className="card-body">
										<h4 className="card-title">Registrations</h4>
										<div className="registrations-info">
											{
												state.profile.doctorRegistrations != undefined &&
												state.profile.doctorRegistrations.map(item => (
													<div className="row form-row reg-cont" key={item.doctorRegistrationId}>
														<div className="col-12 col-md-5">
															<div className="form-group">
																<label>Registrations</label>
																<input type="text" className="form-control" value={item.registrations} onChange={(e) => handleOnChangeRegistration(e, item.doctorRegistrationId, "registrations")} />
															</div>
														</div>
														<div className="col-12 col-md-5">
															<div className="form-group">
																<label>Year</label>
																<input type="text" className="form-control" value={item.year} onChange={(e) => handleOnChangeRegistration(e, item.doctorRegistrationId, "year")} />
															</div>
														</div>
														<div class="col-12 col-md-2">
															<label class="d-md-block d-sm-none d-none">&nbsp;</label>
															<a onClick={() => handleDeleteRegistration(item.doctorRegistrationId)} class="btn btn-danger trash"><i class="far fa-trash-alt"></i></a>
														</div>
													</div>
												))
											}
										</div>
										<div className="add-more">
											<a onClick={() => handleRegistrationAddMore()} className="add-reg"><i className="fa fa-plus-circle"></i> Add More</a>
										</div>
									</div>
								</div>
								<div className="submit-section submit-btn-bottom">
									<button type="submit" className="btn btn-primary submit-btn">Save Changes</button>
								</div>
							</Form>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default DoctorProfileSetting;